import clsx from 'clsx';
import React from 'react';
const SimpleCard = ({ className, shouldHaveBorder = true, ...rest }) => (React.createElement("div", { className: clsx('generic-card', className, { 'with-border': shouldHaveBorder }), ...rest }));
export default SimpleCard;
